export default __webpack_public_path__ + "static/media/chess-nimzo-book(reduced).4deb969d.webp";